import { useEffect } from 'react'

interface KeyboardShortcut {
    key: string
    ctrlKey?: boolean
    metaKey?: boolean
    shiftKey?: boolean
    altKey?: boolean
    preventDefault?: boolean
    callback: () => void
}

export const useKeyboardShortcuts = (shortcuts: KeyboardShortcut[]) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            // event.key can be undefined for some keydown events (e.g. autofill commits, IME
            // composition). Such events can't match a shortcut, so skip them to avoid crashing.
            if (!event.key) return
            shortcuts.forEach((shortcut) => {
                const {
                    key,
                    ctrlKey = false,
                    metaKey = false,
                    shiftKey = false,
                    altKey = false,
                    preventDefault = true,
                    callback
                } = shortcut

                const isMatch =
                    event.key.toLowerCase() === key.toLowerCase() &&
                    event.ctrlKey === ctrlKey &&
                    event.metaKey === metaKey &&
                    event.shiftKey === shiftKey &&
                    event.altKey === altKey

                if (isMatch) {
                    if (preventDefault) {
                        event.preventDefault()
                    }
                    callback()
                }
            })
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [shortcuts])
}
